module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-3.b51d2e7d.png";